import React from "react";
import { Reveal, Kicker, Section } from "@/components/landing/kit";
import { PANIC, ASSETS } from "@/lib/site-data";

const Panic = () => (
  <Section id="panic" className="py-24 sm:py-32">
    <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2 lg:gap-16">
      {/* left copy */}
      <Reveal>
        <Kicker className="mb-6">{PANIC.overline}</Kicker>
        <h2 className="text-balance font-heading text-4xl font-black leading-[0.98] tracking-tight text-[#0F1117] sm:text-6xl">
          Running a marketplace store is a{" "}
          <span className="text-[#2D5BFF]">second full-time job</span> you never applied for.
        </h2>

        <p className="mt-8 font-heading text-xl font-bold text-[#0F1117] sm:text-2xl">
          {PANIC.lead}
        </p>
        {PANIC.paras.map((p, i) => (
          <p key={i} className="mt-4 text-base leading-relaxed text-[#4B5262]">
            {p}
          </p>
        ))}

        <p className="mt-8 font-heading text-lg font-bold leading-snug text-[#0F1117] sm:text-xl">
          Going it alone isn&apos;t a strategy.{" "}
          <span className="text-[#2D5BFF]">
            What wins is a proven team that runs the entire store for you.
          </span>
        </p>
      </Reveal>

      {/* right photo + floating stat */}
      <Reveal delay={0.1} className="relative">
        <div className="relative overflow-hidden rounded-3xl border border-[#E5E8F0] shadow-md">
          <img
            src={ASSETS.founder}
            alt="The DSA eCommerce team"
            className="h-[420px] w-full object-cover object-center sm:h-[520px]"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
        </div>

        <div className="absolute -bottom-6 left-4 max-w-[16rem] rounded-2xl border border-[#2D5BFF]/30 bg-white/95 p-5 shadow-lg backdrop-blur-md sm:left-6">
          <div className="flex items-center gap-2">
            <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[#2D5BFF]" />
            <span className="font-heading text-[11px] font-bold uppercase tracking-[0.2em] text-[#2D5BFF]">
              {PANIC.statCard.label}
            </span>
          </div>
          <p className="mt-2 font-heading text-4xl font-black text-[#0F1117]">
            {PANIC.statCard.value}
          </p>
          <p className="mt-1 text-xs leading-relaxed text-[#5B6375]">
            {PANIC.statCard.body}
          </p>
        </div>
      </Reveal>
    </div>
  </Section>
);

export default Panic;
